import { FieldWrapper } from '@anm/components/EditableField/Wrapper';
import getFromCdn from '@anm/helpers/getFromCdn';
import { folderIconBlock, truncate } from '@anm/styles/helpers';
import styled from 'styled-components';

import { CarretBoxProps, FolderRowProps } from './types';

const Wrapper = styled.div``;

export const FolderRowInfo = styled.div<FolderRowProps>`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 5px;
  border-radius: 5px;
  cursor: pointer;
  background-color: ${({ isActive }) => (isActive ? '#e9f8ff' : 'transparent')};
  border: 1px solid ${({ isActive }) => (isActive ? '#cbdce5' : 'transparent')};
  &:hover {
    background-color: #e9f8ff;
  }
`;

export const CaretBox = styled.span<CarretBoxProps>`
  height: 36px;
  width: 40px;
  padding: 9px 0;
  flex-shrink: 0;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 18px 11px;
  opacity: ${({ visible }) => (visible ? 1 : 0)};
  transform: ${({ isExpanded }) => `rotate(${isExpanded ? 90 : 0}deg)`};
  background-image: url(${getFromCdn('images/dashboard/folder-tree-arrow.svg')});
`;

export const NestedFoldersWrap = styled.div`
  padding-left: 25px;
`;

export const Title = styled.span`
  ${truncate('100%')}
`;

export const FolderName = styled.div`
  ${folderIconBlock};
  display: flex;
  align-items: center;
  padding: 9px 9px 9px 0;
  width: calc(100% - 40px);
`;

export const NewFolderWrapper = styled.div`
  ${folderIconBlock};
  display: flex;
  align-items: center;
  padding: 9px 20px 9px 0;
  flex: 1;
  max-width: calc(100% - 30px);
  &:hover {
    background-color: #e9f8ff;
  }
  input {
    margin-left: -5px;
    margin-top: 1px;
    font-weight: normal;
    background-color: transparent;
    &:focus {
      border-width: 0;
      border-radius: 0;
      border-bottom-width: 1px;
    }
  }
  ${FieldWrapper} {
    max-width: calc(100% - 50px);
  }
`;

export default Wrapper;
